<template>
  <div class="text-xs-center">
    <v-dialog
        v-model="isLoading"
        overlay
        persistent
        width="400"
    >
      <v-card color="primary" dark>
        <v-card-text>
          {{mensagem}}
          <v-progress-linear indeterminate color="secondary" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    name: 'CDLoadingProgress',
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        mensagem: {
            type: String,
            default: 'Carregando...'
        }
    }
}
</script>

<style scoped lang="stylus">

</style>